export default "__VITE_ASSET__BU61DHzo__"